import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works" >

			<Card
				icon={faBriefcase}
				title="Formação Acadêmica"

				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./workLogos/ufcat.png"
								alt="Universidade Federal de Catalão"
								className="work-image"
							/>
							<div className="work-title">Mestrado em Modelagem Computacional</div>
							<div className="work-subtitle">
								Universidade Federal de Catalão
							</div>
							<div className="work-duration"></div>
						</div>

						<div className="work">
							<img
								src="./workLogos/unip.jpg"
								alt="Universidade Unimais"
								className="work-image"
							/>
							<div className="work-title">Bachalerado em Ciências da Computação</div>
							<div className="work-subtitle">
								Universidade Paulista
							</div>
							<div className="work-duration"></div>
						</div>

						<div className="work">
							<img
								src="./workLogos/uniaraxa.png"
								alt="Universidade Federal de Araxa"
								className="work-image" />
							<div className="work-title">Bachalerado em Engenharia</div>
							<div className="work-subtitle">
								Centro Universitário do Planalto de Araxá
							</div>
							<div className="work-duration"></div>
						</div>
					</div>
				}
			/>

			<br />

			<Card
				icon={faBriefcase}
				title="Experiências Profissionais"

				body={
					<div className="works-body">

						<div className="work">
							<img
								src="./workLogos/global-fire.png"
								alt="Auckland University"
								className="work-image"
							/>
							<div className="work-title">Desenvolvedor iOS</div>
							<div className="work-subtitle">
								Global Fire
							</div>
							<div className="work-duration">2023</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/angi.png"
								alt="Telus AI"
								className="work-image"
							/>
							<div className="work-title">Estagiário em Desenvolvimento iOS</div>
							<div className="work-subtitle">
								Angi
							</div>
							<div className="work-duration">2023</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/telus.jpg"
								alt="Universidade Federal de Catalão"
								className="work-image"
							/>
							<div className="work-title">Gerador de dados iOS</div>
							<div className="work-subtitle">
								Telus AI International
							</div>
							<div className="work-duration">2022</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/ifood.png"
								alt="Universidade Federal de Catalão"
								className="work-image"
							/>
							<div className="work-title">Estagiário em Desenvolvimento iOS</div>
							<div className="work-subtitle">
								iFood
							</div>
							<div className="work-duration">2022</div>
						</div>
					</div>
				}
			/>

			<br />

			{/* <Card
				icon={faBriefcase}
				title="Experiências Extracurriculares"
				body={
					<div className="works-body" >

						<div className="work">
							<img
								src="./workLogos/copper.png"
								alt="Copper Mountain"
								className="work-image"
							/>
							<div className="work-title">Lift Operator Crew Lead</div>
							<div className="work-subtitle">
								Copper Mountain, CO - EUA
							</div>
							<div className="work-duration">2023 - 2024</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/sauce-on-copper.jpg"
								alt="Sauce on Copper"
								className="work-image"
							/>
							<div className="work-title">Expo</div>
							<div className="work-subtitle">
								Sauce on Copper, CO - EUA
							</div>
							<div className="work-duration">2023 - 2024</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/nesuto.jpg"
								alt="Nesuto Stadium"
								className="work-image"
							/>
							<div className="work-title">Front Attendant</div>
							<div className="work-subtitle">
								Nesuto Stadium, Auckland - Nova Zelândia
							</div>
							<div className="work-duration">2023</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/viajero-kokopelli.jpg"
								alt="Viajero kokopelli"
								className="work-image"
							/>
							<div className="work-title">Front Desk</div>
							<div className="work-subtitle">
								Viajero Kokopelli, Cusco - Peru
							</div>
							<div className="work-duration">2023</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/copper.png"
								alt="Copper Mountain"
								className="work-image"
							/>
							<div className="work-title">Lift Operator </div>
							<div className="work-subtitle">
								Copper Mountain, CO - EUA
							</div>
							<div className="work-duration">2022 - 2023</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/mountain-creek.jpg"
								alt="Mountain Creek"
								className="work-image"
							/>
							<div className="work-title">IT Front Attendant </div>
							<div className="work-subtitle">
								Mountain Creek, NJ - EUA
							</div>
							<div className="work-duration">2022</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/mountain-creek.jpg"
								alt="Mountain Creek"
								className="work-image"
							/>
							<div className="work-title">Ski Instructor </div>
							<div className="work-subtitle">
								Mountain Creek, NJ - EUA
							</div>
							<div className="work-duration">2021 - 2022</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/equilibrio-fertilizantes.jpg"
								alt="Equilibrio Fertlizantes"
								className="work-image"
							/>
							<div className="work-title">Estágiario em Tecnologia e Informação</div>
							<div className="work-subtitle">
								Equilíbrio Fertilizantes
							</div>
							<div className="work-duration">2021</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/mountain-creek.jpg"
								alt="Mountain Creek"
								className="work-image"
							/>
							<div className="work-title">Lift Operator </div>
							<div className="work-subtitle">
								Mountain Creek, NJ - EUA
							</div>
							<div className="work-duration">2019 - 2020</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/edifica.jpg"
								alt="Edifica"
								className="work-image"
							/>
							<div className="work-title">Estágiario em Engenharia</div>
							<div className="work-subtitle">
								Edifíca Engenharia
							</div>
							<div className="work-duration">2018</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/uniaraxa.png"
								alt="Uniaraxa"
								className="work-image"
							/>
							<div className="work-title">Pesquisador Uniersitário</div>
							<div className="work-subtitle">
								Centro Universítario de Planalto de Araxá
							</div>
							<div className="work-duration">2016 - 2018</div>
						</div>

						<div className="work">
							<img
								src="./workLogos/instintopropaganda.jpg"
								alt="Instinto Propaganda"
								className="work-image"
							/>
							<div className="work-title">Desenvolvedor Web</div>
							<div className="work-subtitle">
								Instinto Propaganda
							</div>
							<div className="work-duration">2011 - 2013</div>
						</div>

					</div>
				}
			/> */}
		</div>
	);
};

export default Works;
